export enum ModelErrorCode {
  UNION_TYPE_VALUE_MISSING_RUNTIME_TYPE,
  UNION_TYPE_VALUE_EXPECTED,
  CANNOT_FIND_OPTION
}


export class ModelError extends Error {
  constructor(public readonly code: ModelErrorCode, message: string = 'ModelError') {
    super(message);
  }
}